var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var SvgNext = function SvgNext(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 65,
    viewBox: "0 0 65 65",
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.8722 12.4201C26.055 11.4666 25.0455 12.0948 25.0567 14.7308V25.645H15.5334C14.5982 25.645 13.7012 26.0158 13.0389 26.676C12.3765 27.3362 12.003 28.232 12 29.1672V31.6125V34.0691C12.0015 34.5316 12.094 34.9893 12.2724 35.4161C12.4508 35.8429 12.7114 36.2303 13.0395 36.5564C13.3677 36.8824 13.7568 37.1406 14.1847 37.3162C14.6125 37.4919 15.0708 37.5815 15.5334 37.58H25.0679V47.6754C25.0679 51.8818 26.7729 51.5678 28.7135 50.5246L51.0019 33.7326C51.2689 33.5054 51.4849 33.2243 51.6358 32.9079C51.7867 32.5914 51.8691 32.2467 51.8776 31.8962C51.886 31.5457 51.8204 31.1974 51.685 30.874C51.5495 30.5507 51.3473 30.2595 51.0916 30.0197L27.8722 12.4201Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.9938 13.611C27.1766 12.6575 26.1671 13.2857 26.1783 15.9217V26.836H16.655C15.7198 26.8359 14.8228 27.2067 14.1604 27.8669C13.4981 28.5271 13.1246 29.423 13.1216 30.3581V32.8035V35.26C13.1231 35.7225 13.2156 36.1803 13.394 36.607C13.5723 37.0338 13.833 37.4212 14.1611 37.7473C14.4892 38.0733 14.8783 38.3315 15.3062 38.5071C15.7341 38.6828 16.1924 38.7724 16.655 38.771H26.1895V48.8663C26.1895 53.0728 27.8945 52.7587 29.8351 51.7155L52.1235 34.9235C52.3905 34.6963 52.6065 34.4153 52.7574 34.0988C52.9083 33.7824 52.9907 33.4376 52.9991 33.0871C53.0076 32.7367 52.942 32.3883 52.8065 32.065C52.6711 31.7416 52.4689 31.4505 52.2132 31.2106L28.9938 13.611Z",
    fill: "white"
  })));
};

export default __webpack_public_path__ + "static/media/next.6cada0b7.svg";
export { SvgNext as ReactComponent };